import React from 'react';
import langConf from "../js/lang";

class ShoppingCart extends React.Component {
    state = { sum: this.props.defaultVal };

    handleClick = () => {
        this.props.changeScreen('cart');
        this.setState({ sum: '' });
    };



    render() {
        let lang = this.props.lang;
        let sumQuantities = 0;
        //let cartColor= '';

        for (let i = 0; i < this.props.allItems.length; i++) {
            sumQuantities += this.props.allItems[i].quantity;
        }
        if (this.props.includeBidItems) {
            for (let i = 0; i < this.props.bidItems.length; i++) {
                sumQuantities += this.props.bidItems[i].quantity;
            }
            //cartColor = 'inverted white';
        }
        return (
            <div className={`col-3 col-xs-6 shopping-cart ${lang === 'hebrew' ? 'hebrew' : 'english'}`} title={langConf[lang].cart} onClick={this.handleClick} style={{ display: 'inline' }}>
                <button className={`btn btn-default btn-block ${lang}`}>
                <i className={`glyphicon glyphicon-shopping-cart`}></i>
                    {`${langConf[lang].cart} (${sumQuantities})`}
                    
                </button>
            </div>
        );
    };
}

export default ShoppingCart;